/**
 * Microsoft Entra ID (Azure AD) / MSAL configuration for SSO.
 * Set these in .env.local (see .env.example).
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID || '',
    authority:
      process.env.REACT_APP_ENTRA_AUTHORITY ||
      `https://login.microsoftonline.com/${process.env.REACT_APP_ENTRA_TENANT_ID || 'common'}`,
    redirectUri: process.env.REACT_APP_ENTRA_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_ENTRA_POST_LOGOUT_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

/**
 * Scopes to request at login. Add more if your app calls Microsoft Graph or your own API.
 */
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile'],
};
